module.exports = __webpack_public_path__ + "static/servicios-otros-439034a6498f3cba4c1849a50f24d894.png";